import React from 'react';
import {BrandingThemeContext} from './brandingTheme';

export function useBrandingTheme() {
  const context = React.useContext(BrandingThemeContext);
  if (context === undefined) {
    throw new Error('useBrandingTheme must be used within a BrandingThemeProvider');
  }
  return context;
}
